import type { BookingSummaryResponse } from '@/models';
import { formatCompactMoney } from '@/constants/currency';

/**
 * A summary card's money figure, in the currency of the bookings behind it.
 *
 * The cards summed every booking into one number and printed it as sterling,
 * so a EUR campaign showed in pounds and a mixed set added euros to pounds.
 * One currency shows in that currency; several show one figure each, largest
 * first, since a single total across them would be in none of them.
 */
export const summaryMoney = (
  summary: BookingSummaryResponse | undefined,
  field: 'gross' | 'net'
): string => {
  if (!summary) return '—';
  const byCurrency = summary.byCurrency ?? [];
  if (byCurrency.length === 0) {
    const total = field === 'gross' ? summary.totalGross : summary.totalNet;
    return typeof total === 'number' && Number.isFinite(total) ? formatCompactMoney(total) : '—';
  }
  return byCurrency.map((c) => formatCompactMoney(c[field], c.currency)).join(' · ');
};
